import { ChevronRight } from "@tamagui/lucide-icons";
import { XStack, Text, Button } from "tamagui";

interface ManualCardProps {
  label: string;
  routePath: string;
  backgroundColor?: string;
}

export const CustomCard = ({
  label,
  routePath,
  backgroundColor = "$gray4",
}: ManualCardProps) => {
  const handlePress = () => {
    // Always open external URL in new tab
    window.open(routePath, "_blank", "noopener,noreferrer");
  };

  return (
    <Button
      onPress={handlePress}
      backgroundColor={backgroundColor}
      borderRadius="$6"
      padding="$4"
      gap="$3"
      height="56px"
      hoverStyle={{ backgroundColor: "$gray6" }}
    >
      <XStack justifyContent="space-between" alignItems="center" width="100%">
        <Text fontSize="$4">{label}</Text>
        <ChevronRight size={24} color="$white12" />
      </XStack>
    </Button>
  );
};

export default CustomCard;
